import styled from 'styled-components'


const Space = styled.div`
    flex: 1 1 auto;
` 

export default Space;